import { useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationService, UpdateOrganizationPayload } from '@services/organization';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useUpdateOrganization = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['organizations', 'update'],
    mutationFn: async (payload: UpdateOrganizationPayload) => {
      return await organizationService.updateOrganization(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast.success(tActionMessages.organizationUpdatedSuccessfully);
    },
    onError: (error: any) => {
      console.error('Update organization error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        error?.toString() ||
        'Failed to update organization';
      toast.error(errorMessage);
    },
  });
};

export default useUpdateOrganization;